import React from "react";

export default function RunwayIdent(props) {
  const {
    activeSide,
    isCrosswind,
    scaleX,
    scaleY,
    originY,
    svgWidth,
    svgHeight,
    he_heading,
    leIdentRectX,
    leIdentRectY,
    identRectWidth,
    identRectHeight,
    identRectStroke,
    leIdentRotation,
    identX,
    leIdentY,
    le_ident,
    heIdentRectX,
    heIdentRectY,
    heIdentY,
    heIdentRotation,
    he_ident,
    originAtCenter,
  } = props;

  const activeColor = isCrosswind
    ? "rgba(245,158,11,0.9)"
    : "rgba(0,232,122,0.9)";

  const activeFill = isCrosswind
    ? "rgba(245,158,11,0.15)"
    : "rgba(0,232,122,0.15)";

  return (
    <svg
      className="runway-ident"
      style={{
        position: "absolute",
        userSelect: "none",
        zIndex: 2,
        transform: `${
          !originAtCenter
            ? `translate(${scaleX}px, calc(${scaleY}px - 50%))`
            : ""
        } rotate(${he_heading}deg)`,
        transformOrigin: !originAtCenter ? `center ${originY}px` : undefined,
      }}
      viewBox={`0 0 ${svgWidth} ${svgHeight}`}
      width={svgWidth}
      height={svgHeight}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* LE ident box */}
      <g>
        <rect
          x={leIdentRectX}
          y={leIdentRectY}
          rx="5"
          width={identRectWidth}
          height={identRectHeight}
          stroke={activeSide === "le" ? activeColor : "rgba(0,212,255,0.3)"}
          strokeWidth={identRectStroke}
          fill={activeSide === "le" ? activeFill : "rgba(10,14,26,0.8)"}
        />
        <text
          x={identX}
          y={leIdentY}
          fontSize="2.6rem"
          textAnchor="middle"
          dominantBaseline="central"
          fill={activeSide === "le" ? activeColor : "rgba(200,220,240,0.9)"}
          fontWeight="bold"
          transform={`rotate(${leIdentRotation} ${identX} ${leIdentY})`}
        >
          {le_ident}
        </text>
      </g>

      {/* HE ident box */}
      <g>
        <rect
          x={heIdentRectX}
          y={heIdentRectY}
          rx="5"
          width={identRectWidth}
          height={identRectHeight}
          stroke={activeSide === "he" ? activeColor : "rgba(0,212,255,0.3)"}
          strokeWidth={identRectStroke}
          fill={activeSide === "he" ? activeFill : "rgba(10,14,26,0.8)"}
        />
        <text
          x={identX}
          y={heIdentY}
          fontSize="2.6rem"
          textAnchor="middle"
          dominantBaseline="central"
          fill={activeSide === "he" ? activeColor : "rgba(200,220,240,0.9)"}
          fontWeight="bold"
          transform={`rotate(${heIdentRotation} ${identX} ${heIdentY})`}
        >
          {he_ident}
        </text>
      </g>
    </svg>
  );
}
